import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { ArrowRight, Sparkles } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

export const CTASection = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const { ref } = useRevealOnScroll<HTMLDivElement>();

  return (
    <section ref={ref} className="reveal-on-scroll">
      <div className="relative rounded-3xl overflow-hidden p-10 md:p-20 text-center bg-gradient-to-br from-primary via-primary-light to-primary shadow-2xl shadow-primary/40">
        {/* Ambient rings */}
        <div aria-hidden className="absolute inset-0 pointer-events-none">
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[140%] aspect-square rounded-full border border-white/15" />
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[100%] aspect-square rounded-full border border-white/15" />
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[60%] aspect-square rounded-full border border-white/20" />
          <div className="absolute -top-24 -right-24 w-80 h-80 rounded-full bg-white/15 blur-3xl" />
          <div className="absolute -bottom-24 -left-24 w-80 h-80 rounded-full bg-white/15 blur-3xl" />
        </div>

        <div className="relative">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/15 border border-white/30 text-white text-[11px] font-semibold tracking-widest uppercase mb-6 backdrop-blur">
            <Sparkles className="w-3.5 h-3.5" />
            Ready to launch
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white tracking-tight mb-4">
            {t("readyToTransform")}
          </h2>
          <p className="text-base md:text-xl text-white/85 max-w-2xl mx-auto mb-8">
            {t("readyToTransformDesc")}
          </p>
          <button
            onClick={() => navigate("/campaign")}
            className="inline-flex items-center gap-2 h-14 px-9 rounded-full bg-white text-primary font-bold text-base shadow-2xl hover:-translate-y-1 transition-transform duration-300 group"
          >
            {t("createYourCampaign")}
            <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-0.5" />
          </button>
        </div>
      </div>
    </section>
  );
};
